import {Component, Inject, OnInit, Optional} from '@angular/core';
import {StoreSelectorsService} from '../../services';
import {Compbaser} from "../compbaser";
import {TranslocoService} from "@ngneat/transloco";
import {ToastrService} from "ngx-toastr";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {IAppSettingsWrap} from "../../interfaces";

@Component({
    selector: 'app-dialog-cors',
    templateUrl: './dialog-cors.component.html',
    styleUrls: ['./dialog-cors.component.scss']
})
export class DialogCorsComponent extends Compbaser implements OnInit {

    constructor(
        @Optional() @Inject(MAT_DIALOG_DATA) data,
        private toastr: ToastrService
    ) {
        super();

    }

    ngOnInit(): void {
    }

    getFrameExt() {
        window.open('https://chrome.google.com/webstore/detail/ignore-x-frame-headers/gleekbfjekiniecknbkamfmkohkpodhe', '_blank');
    }

    copyEmbeddedToClipboard() {
        // copyTextClipboard(this.getEmbeddedHTML());
        // this.toastr.info(this.translocoService.translate('toast.copiedToClipboard', {}, this.translocoService.getActiveLang()), '', TOAST_FASTER);
    }
}

